/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Relacja do przełożonego wskazanego w supervisorEmployeeId. SUBTREE to całe poddrzewo, N_1 do N_3 to dokładnie ten jeden poziom poniżej. Sam przełożony nigdy nie wchodzi do wyniku. 
 * @export
 * @enum {string}
 */

export const TeamMatrixSupervisorRelationDto = {
    Subtree: 'SUBTREE',
    N1: 'N_1',
    N2: 'N_2',
    N3: 'N_3'
} as const;

export type TeamMatrixSupervisorRelationDto = typeof TeamMatrixSupervisorRelationDto[keyof typeof TeamMatrixSupervisorRelationDto];



